import React from "react"

import styled from "styled-components"

import { Grid } from "../../atoms/grid"

import Img from "gatsby-image"

import { StaticQuery, graphql } from "gatsby"
import { Settings } from "../../../styles/theme"

const Breakstyle = styled.div`
  position: relative;
  background: #f4f4f4;
  padding: 1rem 0;
  margin: ${props => (props.venue ? "4rem 0" : "4rem 0 0")};
  overflow: hidden;
  h4 {
    text-align: left !important;
    font-size: 1.5rem;
    margin-bottom: 0;
  }
  a {
    text-align: center;
    margin: 1rem auto;
    text-transform: uppercase;
  }
  .gatsby-image-wrapper,
  img {
    position: absolute !important;
    bottom: 0;
    width: 100%;
    z-index: 0;
  }
  .constraint {
    position: relative;
    z-index: 1;
  }
  .venue {
    display: flex;
    flex-wrap: wrap;
    div {
      flex: 0 0 50%;
    }
    > .venueTitle {
      text-align: right;
      p {
        font-size: 2rem;
        letter-spacing: 0.5rem;
        color: ${Settings.primaryColor};
        position: relative;
        white-space: nowrarp;
        &:after {
          content: " ";
          border: 3px solid ${Settings.primaryColor};
          position: absolute;
          bottom: -5px;
          width: 65px;
          right: 0;
        }
      }
    }
  }
  p {
    color: ${props => (props.venue ? Settings.primaryColor : "#000")};
  }
  .videoPlayer {
    > div {
      width: 100% !important;
    }
  }
`

export const Break = ({ children, venue, video }) => (
  <StaticQuery
    query={graphql`
      query {
        flavor: file(relativePath: { eq: "ships-flavor.png" }) {
          childImageSharp {
            fluid(maxWidth: 1920) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `}
    render={data => (
      <Breakstyle venue={venue}>
        <div className="constraint">
          <Grid columns={venue ? 3 : 2} unstack={video ? false : true}>
            {children}
          </Grid>
        </div>
      </Breakstyle>
    )}
  />
)

const Tabstyle = styled.div`
  position: relative;
  text-align: center;
  margin-top: 2rem;
  padding-bottom: 1rem;
  .constraint {
    max-width: 1440px;
    border-bottom: 4px solid ${Settings.primaryColor};
  }
  a {
    font-size: 1.5rem;
    text-transform: uppercase;
    text-decoration: none;
  }
  .link {
    padding-bottom: 1rem;
    a {
      color: #000;
    }
  }
  .link.active {
    font-weight: 700;
    a {
      color: ${Settings.secondaryColor};
    }
  }
`

export const Tab = ({ children }) => (
  <Tabstyle>
    <div className="constraint">{children}</div>
  </Tabstyle>
)

export const Venu = {}
